module.exports = __webpack_public_path__ + "img/image23.3136afa8.png";